module.exports = __webpack_public_path__ + "static/img/avatar.fc18f715.png";